import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import KeyboardArrowRightRounded from "@mui/icons-material/KeyboardArrowRightRounded";
import StatusChip from "./StatusChip";
import { Proposal } from "../../../../types/proposal.types";

interface ProposalCardProps {
  proposal: Proposal;
  onView?: (id: number) => void;
}

export default function ProposalCard({ proposal, onView }: ProposalCardProps) {
  return (
    <Paper
      sx={{
        borderRadius: 3,
        p: 2.5,
        boxShadow: 0,
        bgcolor: "#f0f4f8",
        border: "1px solid #f0f4f8",
      }}
    >
      {/* Title + Status */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "18px", color: "#1e293b" }}>
          {proposal.title}
        </Typography>
        <StatusChip status={proposal.status} />
      </Stack>

      {/* Info Row */}
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
        <Box>
          <Typography sx={{ fontSize: "11px", color: "#4B5563", mb: 0.3 }}>
            Package
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#94A3B8", fontWeight: 500 }}>
            {proposal.packageName}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "11px", color: "#4B5563", mb: 0.3 }}>
            Estimate Total
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#94A3B8", fontWeight: 500 }}>
            {proposal.estimateTotal}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "11px", color: "#4B5563", mb: 0.3 }}>
            Last Activity
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#94A3B8", fontWeight: 500 }}>
            {proposal.lastActivity}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ mb: 1.5, opacity: 0.6 }} />

      {/* View Proposal */}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={() => onView?.(proposal.id)}
          endIcon={<KeyboardArrowRightRounded />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "13px",
            color: "#86645A",
            p: 0,
            "&:hover": { bgcolor: "transparent", color: "#724e41" },
          }}
        >
          View Proposal
        </Button>
      </Box>
    </Paper>
  );
}